export enum AdmissionType {
  Initial = 'initial',
  FollowUp = 'follow-up',
  Certificate = 'certificate',
  Immunization = 'immunization'
}

export let admissionTypeNameMapper: Readonly<Record<AdmissionType, string>> = {
  [AdmissionType.Initial]: 'Первичный прием',
  [AdmissionType.FollowUp]: 'Повторный прием',
  [AdmissionType.Certificate]: 'Первичный приём с оформлением справки',
  [AdmissionType.Immunization]: 'Первичный прием с вакцинацией'
} as const
